import { useQuery } from "@tanstack/react-query";
import { tournamentApi } from "@bw/shared/api";
import type { TournamentResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * The PUBLIC tournament detail (GET /tournaments/{id} → TournamentResponse,
 * anonymous-readable), keyed by the route tournament id. Read-only; the page
 * renders only the player-relevant fields and NEVER an operator uid
 * (created_by / staff user_id), per frontend-honesty (#1398).
 */
export function useTournamentDetail(tournamentId: string | undefined) {
  return useQuery<TournamentResponse>({
    queryKey: queryKeys.tournaments.detail(tournamentId ?? ""),
    queryFn: () => tournamentApi.getPublic(tournamentId as string),
    enabled: Boolean(tournamentId),
  });
}
